import { createSelector } from 'reselect'
import type { WithFeatureFlagsState } from '../reducers/feature-flags.slice.js'

/**
 * NOTE: These are not necessarily compound selectors, but they dervice from `fetchSystemInfo`,
 * which is used by multiple slices. That thunk is going to use state selectors, while the slices
 * are going to use `fetchSystemInfo`. This avoids circular dependencies.
 */
const state$ = <T extends WithFeatureFlagsState>(s: T) => s.fflags
export const flags$ = /*@__PURE__*/ createSelector(state$, (s) => s.flags)
export const featureSet$ = /*@__PURE__*/ createSelector(flags$, (flags) => flags?.feature_set)
export const featureSetProps$ = /*@__PURE__*/ createSelector(
	flags$,
	(flags) => flags?.feature_set_props,
)
